import type { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_DELETE_EVENT_MODAL } from '../../../config/testIds';
import useDeleteEventMutation from '../../EventsPage/hooks/useDeleteEventMutation';

const antIconDanger = <LoadingOutlined style={{ fontSize: 16, color: 'red' }} spin />;

export interface DeleteEventModalProps {
    open: boolean;
    onClose: () => void;
    eventId: string;
    eventName: string;
    onSuccess?: () => void;
}

const DeleteEventModal: FC<DeleteEventModalProps> = ({ open, onClose, eventId, eventName, onSuccess }) => {
    const { mutate: deleteEvent, isPending } = useDeleteEventMutation({
        onSuccess: () => {
            onClose();
            onSuccess?.();
        },
    });

    return (
        <ConfirmationModal
            data-testid={TPO_DELETE_EVENT_MODAL}
            open={open}
            onCancel={onClose}
            onSubmitClick={() => deleteEvent(eventId)}
            okText={isPending ? <Spin indicator={antIconDanger} /> : 'Delete'}
            okButtonProps={{ type: 'primary', danger: true, style: { borderRadius: 6 } }}
            loading={isPending}
            title={`Are you sure you want to delete ${eventName || 'this event'}?`}
            description={
                // @code-guard: skip-next-line reason="matches existing card style in SaveAsPlanModal/DeletePlanModal"
                <div className="bg-[#fafafa] rounded-lg p-2">
                    {/* @code-guard: skip-next-line reason="matches existing card style in SaveAsPlanModal/DeletePlanModal" */}
                    <p className="text-sm text-[#18181b]">
                        This will permanently remove the event and all its promotions.
                    </p>
                </div>
            }
            width={520}
        />
    );
};

DeleteEventModal.displayName = 'DeleteEventModal';
export default DeleteEventModal;
